import { Directive, HostListener } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[noPropagation]',
	standalone: true,
})
export class NoPropagationDirective {
	@HostListener('click', ['$event'])
	@HostListener('mousedown', ['$event'])
	@HostListener('mouseup', ['$event'])
	@HostListener('keydown', ['$event'])
	@HostListener('keyup', ['$event'])
	@HostListener('keypress', ['$event'])
	@HostListener('touchstart', ['$event'])
	@HostListener('touchend', ['$event'])
	@HostListener('touchmove', ['$event'])
	onEvent(event: Event): void {
		event.stopPropagation();
	}
}
